export const animation = {
  splash: require('./splash.json'),
  loading: require('./loading.json'),
  splash_bg: require('./splash-bg.jpg'),
};
